import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './style.css';
import Dummy from '../Dummy';


export default class Cell extends Dummy {

  render() {
    let cellClass = {};
    cellClass[styles.hovered] = this.props.onClick != null;
    return (
      <div className={classNames(styles.Cell, this.props.div_id, cellClass)}>
        <table onClick={this.props.onClick}>
          <tbody>
            <tr title={this.props.hint} className={this.props.className}>
              <th>{this.props.caption}</th>
              {this.getPsValue(this.props.ps[0], 'td')}
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/lib/core/Cell/index.jsx